import { Injectable } from '@angular/core';
import { GridTableBody, TableCellAttribute, UserTableConstructorInfo } from '../../../../interfaces/tables.interfaces';

import { AccountStatus, AdminBasic, UserBasic } from '../../../../swagger-api';
import { ColumnTypes } from '../../../../views/grid-user-list/grid-table.enum';
import { DatePipe } from '@angular/common';
import AppValues from '../../../../common/app.values';

@Injectable()
export class AdminTableFactory {
  public buildTableData(items: AdminBasic[]): UserTableConstructorInfo {
    return {
      header: this.getTableHeader(),
      body: this.getTableBody(items),
      attribute: this.getManageCellAttribute(),
    };
  }

  private getTableHeader(): ColumnTypes[] {
    return [ColumnTypes.USER, ColumnTypes.REGISTRATION_DATE, ColumnTypes.MANAGE, ColumnTypes.LAST_VISIT];
  }

  private getManageCellAttribute(): TableCellAttribute {
    return { value_class_front: 'remove', key: 'remove' };
  }

  private convertAdminToUserBasic(adminBasic: AdminBasic): UserBasic {
    return {
      user_id: adminBasic.user_id,
      displayed_name: adminBasic.displayed_name,
      is_admin: true,
      image_url: adminBasic.image_url,
      account_status: AccountStatus.ACTIVE,
    };
  }

  private getTableBody(admins: AdminBasic[]): GridTableBody[] {
    return admins.map((admin: AdminBasic) => {
      const user: UserBasic = this.convertAdminToUserBasic(admin);
      return {
        user: user,
        entityId: user.user_id,
        actorId: user.user_id,
        created: new DatePipe('en-US').transform(admin.created_date, AppValues.DATE_FORMAT_SHORT),
        is_admin: user.is_admin,
        account_status: user.account_status,
        last_visit: admin.last_visit_date,
      };
    });
  }
}
